/**
 * View utilized by the {@link module:app#app:alert|app:alert} to display alerts to the user
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/alertView.html';

class AlertView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.events = _.extend(
			{
				'click [data-nx-control="dismiss"]:first': 'hide',
			},
			opts.events,
		);
		opts.id = opts.id || _.uniqueId('alert-');
		opts.modalOptions = _.extend(
			{
				blocking: true,
			},
			opts.modalOptions,
		);
		opts.removeOnHide = opts.removeOnHide !== false;
		opts.template = opts.template || Template;
		super(opts);

		this.alertClass = opts.alertClass;
		this.msg = opts.msg;
		this.type = opts.type;

		if (this.model) {
			this.headerTitle = this.model.get('type');
		}
	}

	/**
	 * @static
	 * @type {string}
	 */
	static get __name__() {
		return 'AlertView';
	}
}

export default AlertView;
